import {ModelContext} from '../../types/app.types';
import {SPECS} from '../specs';

export class PriceModel {
  public convertedAmount: number;
  public formattedConvertedAmount: string;

  constructor(params: PriceModel) {
    this.convertedAmount = params.convertedAmount;
    this.formattedConvertedAmount = params.formattedConvertedAmount;
  }

  public static fromGQL({
    convertedAmount,
    formattedConvertedAmount,
    modelContext,
  }: {
    convertedAmount?: number;
    formattedConvertedAmount?: string;
    modelContext: ModelContext;
  }) {
    return new PriceModel({
      convertedAmount,
      formattedConvertedAmount: modelContext.viewerContext.isExperimentEnabled(SPECS.ClientFormattingForPrices)
        ? modelContext.formatAmount(convertedAmount)
        : formattedConvertedAmount,
    });
  }

  public static fromSDK(
    multiCurrencyPrice: {convertedAmount?: string; formattedConvertedAmount?: string},
    modelContext: ModelContext
  ) {
    return new PriceModel({
      convertedAmount: parseFloat(multiCurrencyPrice?.convertedAmount),
      formattedConvertedAmount: modelContext.viewerContext.isExperimentEnabled(SPECS.ClientFormattingForPrices)
        ? modelContext.formatAmount(multiCurrencyPrice?.convertedAmount)
        : multiCurrencyPrice?.formattedConvertedAmount,
    });
  }
}
